export const POS_TERMINAL_SET = "POS_TERMINAL_SET";
export const POS_TERMINALS_LIST = "POS_TERMINALS_LIST";
export const POS_TERMINAL_LOADING = "POS_TERMINAL_LOADING";
